import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CountryModel } from '../../../domain/models/configuration/country.model';
import { TypeDocumentModel } from '../../../domain/models/configuration/type-document.model';
import { ConfigurationRepository } from '../../../domain/repositories/configuration.repository';
import { CountryEntity } from './entities/country.entity';
import { TypeDocumentEntity } from './entities/type-document.entity';
import { CountryImplementationRepositoryMapper } from './mappers/country-repository.mapper';
import { TypeDocumentImplementationRepositoryMapper } from './mappers/type-document.repository.mapper';
import { TypeCanalModel } from '../../../domain/models/configuration/type-canal.model';
import {
  DataTypeCanalEntity,
  TypeCanalEntity,
} from './entities/type-canal.entity';
import { TypeCanalImplementationRepositoryMapper } from './mappers/type-canal.repository.mapper';
import { CityImplementationRepositoryMapper } from './mappers/city.repository.mapper';
import { CityModel } from '../../../domain/models/configuration/city.model';
import { CanalModel } from '../../../domain/models/configuration/canal.model';
import { StateProspectModel } from '../../../domain/models/configuration/state-prospect.model';
import { CanalImplementationRepositoryMapper } from './mappers/canal.repository.mapper';
import { TypeBloodModel } from '../../../domain/models/configuration/type-blood';
import { TypeBloodImplementationRepositoryMapper } from './mappers/type-blood-repository.mapper';
import { TypeBloodEntity } from './entities/type-blood.entity';
import { CompanyImplementationRepositoryMapper } from './mappers/company/company.repository.mapper';
import { CompanyEntity } from './entities/company/company.entity';
import { CompanyModel } from '../../../domain/models/configuration/company/company.model';
import { ConsultancyModel } from '../../../domain/models/configuration/company/consultancy.model';
import { ConsultancyEntity } from './entities/company/consultancy.entity';
import { TypeServiceModel } from '../../../domain/models/configuration/company/type-service.model';
import { TypeServiceEntity } from './entities/company/type-service.entity';
import { TypeServiceImplementationRepositoryMapper } from './mappers/company/type-service.repository.mapper';
import { ServiceImplementationRepositoryMapper } from './mappers/company/service.repository.mapper';
import { ServiceModel } from '../../../domain/models/configuration/company/service.model';
import { ServiceEntity } from './entities/company/service.entity';
import { ConsultancyImplementationRepositoryMapper } from './mappers/company/consultancy.repository.mapper';
import { CollaboratorModel, DataCollaboratorModel } from '../../../domain/models/configuration/company/collaborator.model';
import { CololaboratorImplementationRepositoryMapper } from './mappers/company/collaborator.repository.mapper';
import { CollaboratorEntity } from './entities/company/collaborator.entity';
import { StateCivilImplementationRepositoryMapper } from './mappers/state-civil.mapper';
import { EPSImplementationRepositoryMapper } from './mappers/eps.repository.mapper';
import { GenderImplementationRepositoryMapper } from './mappers/gender.repository.mapper';
import { RelationShipImplementationRepositoryMapper } from './mappers/relationchip.mapper';
import { StateCivilModel } from '../../../domain/models/configuration/state-civil.model';
import { StateCivilEntity } from './entities/state-civil.entity';
import { EPSModel } from '../../../domain/models/configuration/eps.model';
import { EPSEntity } from './entities/eps.entity';
import { GenderModel } from '../../../domain/models/configuration/gender.model';
import { GenderEntity } from './entities/gender.entity';
import { RelationShipModel } from '../../../domain/models/configuration/relationship.model';
import { RelationShipEntity } from './entities/relationship.entity';
import { AgreementModel } from '../../../domain/models/configuration/agreement.model';
import { AgreementEntity } from './entities/agreement.entity';
import { AgreementImplementationRepositoryMapper } from './mappers/agreement.repository.mapper';
import { PrepaidMedicineImplementationRepositoryMapper } from './mappers/prepaid-medicine.repository.mapper';
import { PrepaidMedicineModel } from '../../../domain/models/configuration/prepaid-medicinal.model';
import { PrepaidMedicineEntity } from './entities/prepaid-medicine.entity';
import { DiagnosticModel } from '../../../domain/models/configuration/diagnostic.model';
import { DiagnosticImplementationRepositoryMapper } from './mappers/diagnostic.repository.mapper';
import { RevisionModel } from '../../../domain/models/configuration/revision.model';
import { RevisionEntity } from './entities/revision.entity';
import { RevisionImplementationRepositoryMapper } from './mappers/revision.repository.mapper';
import { DepartamentImplementationRepositoryMapper } from './mappers/departament.repository.mapper';
import { DepartamentModel } from '../../../domain/models/configuration/departament.model';
import { StateProspectImplementationRepositoryMapper } from './mappers/state-prospect.repository.mapper';
import { StateProspectFollowupImplementationRepositoryMapper } from './mappers/state-prospect-followup.repository.mapper';
import { StateProspectFollowupModel } from '../../../domain/models/configuration/state-prospect-followup.model';
import { LocationModel } from '../../../domain/models/configuration/location.model';
import { LocationEntity } from './entities/location.entity';
import { LocationImplementationRepositoryMapper } from './mappers/location.repository.mapper';
import { InvoiceModel } from '../../../domain/models/configuration/invoice.model';
import { TypeInvoiceImplementationRepositoryMapper } from './mappers/type-invoice.repository.mapper';
import { InvoiceImplementationRepositoryMapper } from './mappers/invoice.repository.mapper';
import { TypeInvoiceModel } from '../../../domain/models/configuration/type-invoice.model';
import { InvoiceResponseModel } from '../../../domain/models/configuration/invoice-response.model';
import { InvoiceResponseEntity } from './entities/invoice-response.entity';
import { TypeInvoiceEntity } from './entities/type-invoice.entity';
import { ProfessionalModel } from '../../../domain/models/configuration/professional.model';
import { ProfessionalEntity } from './entities/professional.entity';
import { ProfessionalImplementationRepositoryMapper } from './mappers/professional.repository.mapper';
import { PendingInvoiceReportImplementationRepositoryMapper } from './mappers/pending-invoice-report.repository.mapper';
import { PendingInvoiceReportModel } from '../../../domain/models/configuration/pending-invoice-report.model';
import { PendingInvoiceReportEntity } from './entities/pending-invoice-report.entity';
import { ConsentImplementationRepositoryMapper } from './mappers/consent.repository.mapper';
import {
  ConsentModel,
  DataConsentModel,
} from '../../../domain/models/configuration/consent.model';
import { ConsentEntity } from './entities/consent.entity';
import { OrganizationModel } from '../../../domain/models/configuration/type-organization.model';
import { OrganizationEntity } from './entities/organization.entity';
import { ConvenioImplementationRepositoryMapper } from './mappers/convenio.repository.mapper';
import { ConvenioModel } from '../../../domain/models/configuration/convenio.model';
import { MetodoPagoSaludModel } from '../../../domain/models/configuration/metodo-pago-salud.model';
import { MetodoPagoSaludEntity } from './entities/metodo-pago-salud.entity';
import { MetodoPagoSaludImplementationRepositoryMapper } from './mappers/metodo-pago-salud.repository.mapper';
import { OriginImplementationRepositoryMapper } from '../consult/mappers/origin.repository.mapper';
import { OrganizationImplementationRepositoryMapper } from './mappers/type-organization.repository.mapper';
import { TipoPlanSaludImplementationRepositoryMapper } from './mappers/tipo-plan-salud.repository.mapper';
import { MetodoPagoFinancieroModel } from '../../../domain/models/configuration/metodo-pago-financiero.model';
import { TipoPlanSaludModel } from '../../../domain/models/configuration/tipo-plan-salud.model';
import { TipoPlanSaludEntity } from './entities/tipo-plan-salud.entity';
import { ConvenioEntity, DataConvenioEntity } from './entities/convenio.entity';
import { ThirdCompanyResponseModel } from '../../../domain/models/configuration/company/third-company.model';
import {
  DataThirdCompanyEntity,
  ThirdCompanyResponseEntity,
} from './entities/company/third-company.entity';
import { ThirdCompanyImplementationRepositoryMapper } from './mappers/company/third-company.repository.mapper';
import { FiscalResponsibilityModel } from '../../../domain/models/configuration/fiscal-responsibility.usecase';
import { FiscalResponsibilityEntity } from './entities/fiscal-responsability.entity';
import { FiscalResponsibilityImplementationRepositoryMapper } from './mappers/fiscal-responsability.mapper';
import { InvoiceRIPSConfigurationModel } from '../../../domain/models/configuration/invoice-rips-configuration.model';
import { InvoiceRIPSConfigurationImplementationRepositoryMapper } from './mappers/invoice-rips-configuration.mapper';
import {
  DataInvoiceRIPSConfigurationEntity,
  InvoiceRIPSConfigurationEntity,
} from './entities/invoice-rips-configuration/invoice-rips-configuration.entity';
import { OrganizationTypeInvoiceRIPSModel } from '../../../domain/models/configuration/organization-type-invoice-rips.model';
import { OrganizationTypeInvoiceRIPSEntity } from './entities/organization-type-invoice-rips.entity';
import { EnablingCodeModel } from '../../../domain/models/configuration/enabling-code.model';
import { EnablingsCodeEntity } from './entities/enablings-code.entity';
import { EnablingsCodeImplementationRepositoryMapper } from './mappers/enablings-code.mapper';
import { BusinessImplementationRepositoryMapper } from './mappers/company/business.repository.mapper';
import {
  BusinessModel,
  DataBusinessModel,
} from '../../../domain/models/configuration/company/business.model';
import { BusinessEntity, DataBusinessEntity } from './entities/company/business.entity';
import { TypeBusinessImplementationRepositoryMapper } from './mappers/company/type-business.repository.mapper';
import { TypeBusinessModel } from '../../../domain/models/configuration/company/type-business.model';
import { ComercialModel } from '../../../domain/models/comercial/comercial.model';
import { ComercialEntity } from '../comercial/entities/comercial.entity';
import { ComercialImplementationRepositoryMapper } from '../comercial/mappers/comercial-repository.mapper';
import { ChargeModel } from '../../../domain/models/configuration/charge.model';
import { ChargeEntity } from './entities/charge.entity';
import { ChargeImplementationRepositoryMapper } from './mappers/charge.mapper';
import {
  DataDemoBusinessModel,
  DemoBusinessModel,
} from '../../../domain/models/configuration/company/demo-business.model';
import { DemoBusinessEntity } from './entities/company/demo-business.entity';
import { DemoBusinessImplementationRepositoryMapper } from './mappers/company/demo-business.repository.mapper';
import { HeadquartersModel } from '../../../domain/models/configuration/company/headquarters.model';
import { HeadquartersImplementationRepositoryMapper } from './mappers/company/headquarters.repository.mapper';
import { DataHeadquartersEntity, HeadquartersEntity } from './entities/company/headquarters.entity';
import { OfficesImplementationRepositoryMapper } from './mappers/company/offices.repository.mapper';
import { OfficesModel } from '../../../domain/models/configuration/company/offices.model';
import { DataOfficesEntity, OfficesEntity } from './entities/company/offices.entity';
import { StateCollaboratorModel } from '../../../domain/models/configuration/company/state-collaborator.model';
import { StateCollaboratorEntity } from './entities/company/state-collaborator.entity';
import { StateCollaboratorImplementationRepositoryMapper } from './mappers/company/state-collaborator.repository.mapper';
import { CollaboratorPositionEntity } from './entities/company/collaboratorPosition.entity';
import { CollaboratorPositionRepositoryMapper } from './mappers/company/collaborator-position.repository.mapper';
import { CollaboratorPositionModel, DataCollaboratorPositionModel } from '../../../domain/models/configuration/company/collaboratorposition.model';
import { PlanBusinessEntity } from './entities/company/plan-business.entity';
import { PlanBusinessModel } from '../../../domain/models/configuration/company/plan-business.model';
import { PlanBusinessImplementationRepositoryMapper } from './mappers/company/plan-business.repository.mapper';
import { DocumentsSystemImplementationRepositoryMapper } from './mappers/documents-system.repository.mapper';
import { DocumentsSystemEntity } from './entities/documents-system.entity';
import { DataDocumentsSystemModel, DocumentsSystemModel } from '../../../domain/models/configuration/documents-system.model';
import { FileDocumentsSystemImplementationRepositoryMapper }
from './mappers/file-documents-system.repository.mapper';
import { DataFileDocumentsSystemModel, FileDocumentsSystemModel } from '../../../domain/models/configuration/file-documents-system.model';
import { FileDocumentsSystemEntity } from './entities/file-documents-system.entity';
import { ChannelSendImplementationRepositoryMapper }
from './mappers/channel-send.repository.mapper';
import { ChannelSendModel, DataChannelSendModel } from '../../../domain/models/configuration/channel-send.model';
import { ChannelSendEntity, DataChannelSendEntity } from './entities/channel-send.entity';
import { MenuImplementationRepositoryMapper }
from './mappers/menu.repository.mapper';
import { DataMenuModel, MenuModel }
from '../../../domain/models/configuration/menu.model';
import {
  MenuEntity
}
from './entities/menu.entity';

import { PerfilImplementationRepositoryMapper }
from './mappers/perfil.repository.mapper';

import { DataPerfilModel, PerfilModel }
from '../../../domain/models/configuration/perfil.model';

import {
  PerfilEntity
}
from './entities/perfil.entity';


import { PerfilMenuImplementationRepositoryMapper }
from './mappers/perfil-menu.repository.mapper';


import { PerfilMenuModel, DataPerfilMenuModel }
from '../../../domain/models/configuration/perfil-menu.model';

import {
  PerfilMenuEntity
}
from './entities/perfil-menu.entity';
import { DataScheduleProfessionalModel, ScheduleProfessionalModel } from '../../../domain/models/configuration/schedule-professional.model';
import { ScheduleProfessionalEntity } from './entities/schedule-professional.entity';
import { ScheduleProfessionalImplementationRepositoryMapper } from './mappers/schedule-professional.repository.mapper';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationImplementationRepository extends ConfigurationRepository {
  country = new CountryImplementationRepositoryMapper();
  charge = new ChargeImplementationRepositoryMapper();
  enablingsCode = new EnablingsCodeImplementationRepositoryMapper();
  fiscalResponsability =
    new FiscalResponsibilityImplementationRepositoryMapper();
  metodoPagoSalud = new MetodoPagoSaludImplementationRepositoryMapper();
  metodoPagoFinanciero = new MetodoPagoSaludImplementationRepositoryMapper();
  tipoPlanSalud = new TipoPlanSaludImplementationRepositoryMapper();
  typeOrganization = new OrganizationImplementationRepositoryMapper();
  comercial = new ComercialImplementationRepositoryMapper();
  departament = new DepartamentImplementationRepositoryMapper();
  city = new CityImplementationRepositoryMapper();
  location = new LocationImplementationRepositoryMapper();
  typeDoc = new TypeDocumentImplementationRepositoryMapper();
  typeCanal = new TypeCanalImplementationRepositoryMapper();
  convenio = new ConvenioImplementationRepositoryMapper();
  headquarters = new HeadquartersImplementationRepositoryMapper();
  offices = new OfficesImplementationRepositoryMapper();
  invoiceRIPSConfiguration =
    new InvoiceRIPSConfigurationImplementationRepositoryMapper();
  canal = new CanalImplementationRepositoryMapper();
  state = new StateProspectImplementationRepositoryMapper();
  stateFollow = new StateProspectFollowupImplementationRepositoryMapper();
  blood = new TypeBloodImplementationRepositoryMapper();
  company = new CompanyImplementationRepositoryMapper();
  consultancy = new ConsultancyImplementationRepositoryMapper();
  typeService = new TypeServiceImplementationRepositoryMapper();
  service = new ServiceImplementationRepositoryMapper();
  collaborator = new CololaboratorImplementationRepositoryMapper();
  statecivil = new StateCivilImplementationRepositoryMapper();
  eps = new EPSImplementationRepositoryMapper();
  gender = new GenderImplementationRepositoryMapper();
  relationship = new RelationShipImplementationRepositoryMapper();
  agreement = new AgreementImplementationRepositoryMapper();
  medicine = new PrepaidMedicineImplementationRepositoryMapper();
  diagnostic = new DiagnosticImplementationRepositoryMapper();
  revision = new RevisionImplementationRepositoryMapper();
  typeInvoice = new TypeInvoiceImplementationRepositoryMapper();
  invoice = new InvoiceImplementationRepositoryMapper();
  invoiceReport = new PendingInvoiceReportImplementationRepositoryMapper();
  professional = new ProfessionalImplementationRepositoryMapper();
  consent = new ConsentImplementationRepositoryMapper();
  thirdCompany = new ThirdCompanyImplementationRepositoryMapper();
  bussiness = new BusinessImplementationRepositoryMapper<DataBusinessModel>();
  bussinessAdmin =  new BusinessImplementationRepositoryMapper<DataBusinessModel[]>();
  typeBusiness = new TypeBusinessImplementationRepositoryMapper();
  demoBusiness = new DemoBusinessImplementationRepositoryMapper();
  stateCollaborator = new StateCollaboratorImplementationRepositoryMapper();
  collaboratorPosition = new CollaboratorPositionRepositoryMapper();
  planBussines =  new PlanBusinessImplementationRepositoryMapper();
  documentssystem = new DocumentsSystemImplementationRepositoryMapper();
  filedocumentssystem = new FileDocumentsSystemImplementationRepositoryMapper();
  channelsend = new ChannelSendImplementationRepositoryMapper();
  menu = new MenuImplementationRepositoryMapper();
  perfil = new PerfilImplementationRepositoryMapper();
  perfilmenu = new PerfilMenuImplementationRepositoryMapper();
  scheduleProfessional = new ScheduleProfessionalImplementationRepositoryMapper();

  business =
  new BusinessImplementationRepositoryMapper();

  url = environment.baseUrl;
  constructor(private http: HttpClient) {
    super();
  }

  override getCountry(): Observable<CountryModel> {
    return this.http
      .get<CountryEntity>(`${this.url}/Paises/GetAll`)
      .pipe(map(this.country.mapFrom));
  }

  override getCharge(): Observable<ChargeModel> {
    return this.http
      .get<ChargeEntity>(`${this.url}/Cargos/GetAll`)
      .pipe(map(this.charge.mapFrom));
  }

  override getTypeService(): Observable<TypeServiceModel> {
    return this.http
      .get<TypeServiceEntity>(`${this.url}/TiposServicio/GetAll`)
      .pipe(map(this.typeService.mapFrom));
  }

  override getEnablingsCode(): Observable<EnablingCodeModel> {
    return this.http
      .get<EnablingsCodeEntity>(
        `${this.url}/OperacionesRIPS/RIPSCodigoPrestadorListByCompanyId`
      )
      .pipe(map(this.enablingsCode.mapFrom));
  }

  override getFiscalResponsibility(): Observable<FiscalResponsibilityModel> {
    return this.http
      .get<FiscalResponsibilityEntity>(
        `${this.url}/FiscalResponsibilityType/GetAll`
      )
      .pipe(map(this.fiscalResponsability.mapFrom));
  }

  override getMetodoPagoSalud(): Observable<MetodoPagoSaludModel> {
    return this.http
      .get<MetodoPagoSaludEntity>(
        `${this.url}/Catalogo/HealthSectorPaymentMethods`
      )
      .pipe(map(this.metodoPagoSalud.mapFrom));
  }
  override getMetodoPagoFinanciero(): Observable<MetodoPagoFinancieroModel> {
    return this.http
      .get<MetodoPagoSaludEntity>(`${this.url}/Catalogo/PaymentsPaymentMethods`)
      .pipe(map(this.metodoPagoFinanciero.mapFrom));
  }
  override getTipoPlanSalud(): Observable<TipoPlanSaludModel> {
    return this.http
      .get<TipoPlanSaludEntity>(`${this.url}/Catalogo/BenefitsPlanTypes`)
      .pipe(map(this.tipoPlanSalud.mapFrom));
  }

  override getTypeOrganization(): Observable<OrganizationModel> {
    return this.http
      .get<OrganizationEntity>(`${this.url}/TiposOrganizacion/GetAll`)
      .pipe(map(this.typeOrganization.mapFrom));
  }

  override getUsers(): Observable<ComercialModel> {
    return this.http
      .get<ComercialEntity>(`${this.url}/ProspectosCliente/GetAllUser`)
      .pipe(map(this.comercial.mapFrom));
  }

  override getOrganizationTypeInvoiceRIPS(): Observable<OrganizationTypeInvoiceRIPSModel> {
    return this.http
      .get<OrganizationTypeInvoiceRIPSEntity>(
        `${this.url}/OrganizationType/GetAll`
      )
      .pipe(map(this.typeOrganization.mapFrom));
  }

  override getDepartament(params: { id: string }): Observable<CityModel> {
    return this.http
      .post<DepartamentModel>(
        `${this.url}/Departamentos/GetAllByCountryId`,
        params
      )
      .pipe(map(this.departament.mapFrom));
  }

  override getLocation(params: { id: string }): Observable<LocationModel> {
    return this.http
      .post<LocationEntity>(`${this.url}/Localidades/GetAllByCountryId`, params)
      .pipe(map(this.location.mapFrom));
  }

  override getCity(params: { id: string }): Observable<CityModel> {
    return this.http
      .post<CityModel>(`${this.url}/Ciudades/GetAllByStateId`, params)
      .pipe(map(this.city.mapFrom));
  }

  override getTypeDocument(params: {
    idCountry: string;
  }): Observable<TypeDocumentModel> {
    return this.http
      .get<TypeDocumentEntity>(
        `${this.url}/TiposDocumento/GetAll/${params.idCountry}`
      )
      .pipe(map(this.typeDoc.mapFrom));
  }

  override getStateProspect(): Observable<StateProspectModel> {
    return this.http
      .get<StateProspectModel>(`${this.url}/EstadosProspecto/GetAll`)
      .pipe(map(this.state.mapFrom));
  }

  override getStateProspectFollowup(): Observable<StateProspectFollowupModel> {
    return this.http
      .get<StateProspectFollowupModel>(
        `${this.url}/TiposSeguimientoProspecto/GetAll`
      )
      .pipe(map(this.stateFollow.mapFrom));
  }

  override getCanal(params: { idTypeCanal: string }): Observable<CanalModel> {
    return this.http
      .get<CanalModel>(
        `${this.url}/Canales/GetAllByChannelType/${params.idTypeCanal}`
      )
      .pipe(map(this.canal.mapFrom));
  }

  override getTypeBlood(): Observable<TypeBloodModel> {
    return this.http
      .get<TypeBloodEntity>(`${this.url}/TiposSangre/GetAll`)
      .pipe(map(this.blood.mapFrom));
  }

  override getStateCivil(): Observable<StateCivilModel> {
    return this.http
      .get<StateCivilEntity>(`${this.url}/EstadosCiviles/GetAll`)
      .pipe(map(this.statecivil.mapFrom));
  }
  override getEPS(params: { idCountry: string }): Observable<EPSModel> {
    return this.http
      .get<EPSEntity>(`${this.url}/EPS/GetAllByCountryId/${params.idCountry}`)
      .pipe(map(this.eps.mapFrom));
  }
  override getGender(): Observable<GenderModel> {
    return this.http
      .get<GenderEntity>(`${this.url}/Generos/GetAll`)
      .pipe(map(this.gender.mapFrom));
  }
  override getRelationship(): Observable<RelationShipModel> {
    return this.http
      .get<RelationShipEntity>(`${this.url}/Parentescos/GetAll`)
      .pipe(map(this.relationship.mapFrom));
  }

  override getAgreement(): Observable<AgreementModel> {
    return this.http
      .get<AgreementEntity>(`${this.url}/ConveniosEmpresa/GetAllByCompanyId`)
      .pipe(map(this.agreement.mapFrom));
  }

  override getPrepaidMedicine(params: {
    idCountry: string;
  }): Observable<PrepaidMedicineModel> {
    return this.http
      .get<PrepaidMedicineEntity>(
        `${this.url}/EntidadesMedicinaPrepagada/GetAllByCountryId/${params.idCountry}`
      )
      .pipe(map(this.medicine.mapFrom));
  }

  override getDiagnostic(params: {
    idCountry: string;
  }): Observable<DiagnosticModel> {
    return this.http
      .get<DiagnosticModel>(
        `${this.url}/Diagnosticos/GetAllByCountryIdSimple/${params.idCountry}`
      )
      .pipe(map(this.diagnostic.mapFrom));
  }

  override getRevision(): Observable<RevisionModel> {
    return this.http
      .get<RevisionEntity>(`${this.url}/OpcionesRevisionSistema/GetAll`)
      .pipe(map(this.revision.mapFrom));
  }

  /**Type Canal */
  override getTypeCanal(): Observable<TypeCanalModel> {
    return this.http
      .get<TypeCanalEntity>(`${this.url}/TiposCanal/GetAll`)
      .pipe(map(this.typeCanal.mapFrom));
  }

  override insertTypeCanal(
    params: DataTypeCanalEntity
  ): Observable<TypeCanalModel> {
    return this.http
      .post<TypeCanalEntity>(`${this.url}/TiposCanal/Insert`, params)
      .pipe(map(this.typeCanal.mapFrom));
  }

  override deleteTypeCanal(params: { Id: string }): Observable<TypeCanalModel> {
    return this.http
      .delete<TypeCanalEntity>(`${this.url}/TiposCanal/Delete/${params.Id}`)
      .pipe(map(this.typeCanal.mapFrom));
  }

  override updateTypeCanal(
    params: DataTypeCanalEntity
  ): Observable<TypeCanalModel> {
    return this.http
      .put<TypeCanalEntity>(`${this.url}/TiposCanal/Update`, params)
      .pipe(map(this.typeCanal.mapFrom));
  }

  /** Company */
  override getCampusCompany(): Observable<CompanyModel> {
    return this.http
      .get<CompanyEntity>(`${this.url}/SedesEmpresa/GetAllByCompanyId`)
      .pipe(map(this.company.mapFrom));
  }


  override getConsultancyCompany(params: {
    IdCampus: string;
  }): Observable<ConsultancyModel> {
    return this.http
      .get<ConsultancyEntity>(
        `${this.url}/ConsultoriosSedeEmpresa/GetAllByCompanyHeadquarterId/${params.IdCampus}`
      )
      .pipe(map(this.consultancy.mapFrom));
  }

  override getTypeServiceCompany(params: {
    IdConsulting: string;
  }): Observable<TypeServiceModel> {
    return this.http
      .get<TypeServiceEntity>(
        `${this.url}/TiposServicioEmpresa/GetAllByHeadquartersId/${params.IdConsulting}`
      )
      .pipe(map(this.typeService.mapFrom));
  }

  override getService(params: {
    idTipoServicio: string;
  }): Observable<ServiceModel> {
    return this.http
      .post<ServiceEntity>(`${this.url}/Servicios/ByServiceTypeId`, {
        idTipoServicio: params.idTipoServicio,
      })
      .pipe(map(this.service.mapFrom));
  }

  override getServiceByCompanyid(): Observable<ServiceModel> {
    return this.http
      .get<ServiceEntity>(`${this.url}/Servicios/ListByCompanyId`)
      .pipe(map(this.service.mapFrom));
  }

  override getServiceCompany(params: {
    IdTypeService: string;
  }): Observable<ServiceModel> {
    return this.http
      .get<ServiceEntity>(
        `${this.url}/ServiciosEmpresa/GetAllByCompanyIdServiceTypeId/${params.IdTypeService}`
      )
      .pipe(map(this.service.mapFrom));
  }

  override getCollaboratorCompany(params: {
    IdService: string;
  }): Observable<CollaboratorModel> {
    return this.http
      .get<CollaboratorEntity>(
        `${this.url}/ColaboradoresEmpresa/GetProffesionalByServicesCompanyId/${params.IdService}`
      )
      .pipe(map(this.collaborator.mapFrom));
  }

  override getProfesionalByCompanyid(params: {
    idSedeEmpresa: string;
    idServicioEmpresa: string;
  }): Observable<CollaboratorModel> {
    return this.http
      .post<CollaboratorEntity>(
        `${this.url}/ColaboradoresEmpresa/GetProffesionalByCompanyIdByCompanyServiceIdByCompanySiteId`,
        params
      )
      .pipe(map(this.collaborator.mapFrom));
  }

    override insertCollaborator(params: DataCollaboratorModel): Observable<CollaboratorModel> {
    return this.http
     .post<CollaboratorEntity>(
        `${this.url}/ColaboradoresEmpresa/Insert`,
        params
      )
      .pipe(map(this.collaborator.mapFrom));
  }

  override insertCollaboratorAllAdmin(
    params: DataCollaboratorModel
  ): Observable<CollaboratorModel> {
    return this.http
      .post<CollaboratorEntity>(
        `${this.url}/ColaboradoresEmpresa/InsertAdmin`,
        params
      )
      .pipe(map(this.collaborator.mapFrom));
  }

  override updateCollaborator(params: DataCollaboratorModel): Observable<CollaboratorModel> {
    return this.http
     .put<CollaboratorEntity>(
        `${this.url}/ColaboradoresEmpresa/Update`,
        params
      )
      .pipe(map(this.collaborator.mapFrom));
  }

  override updateCollaboratorAllAdmin(
    params: DataCollaboratorModel
  ): Observable<CollaboratorModel> {
    return this.http
      .post<CollaboratorEntity>(
        `${this.url}/ColaboradoresEmpresa/UpdateAdmin`,
        params
      )
      .pipe(map(this.collaborator.mapFrom));
  }

  override getCollaboratorCompanyAll():Observable<CollaboratorModel>{
    return this.http
      .get<CollaboratorEntity>(
        `${this.url}/ColaboradoresEmpresa/GetAll`
      )
      .pipe(map(this.collaborator.mapFrom));
  }

  override getCollaboratorAllAdmin(
    params: { idEmpresa: string}
  ): Observable<CollaboratorModel> {
    return this.http
      .post<CollaboratorEntity>(
        `${this.url}/ColaboradoresEmpresa/GetAllAdmin`,
        params
      )
      .pipe(map(this.collaborator.mapFrom));
  }

  override getStateCollaborator(): Observable<StateCollaboratorModel> {
    return this.http
      .get<StateCollaboratorEntity>(`${this.url}/EstadosColaborador/GetAll`)
      .pipe(map(this.stateCollaborator.mapFrom));
  }

  override getPlanBussines(): Observable<PlanBusinessModel> {
    return this.http
      .get<PlanBusinessEntity>(`${this.url}/PlanesEmpresa/GetCompanyById`)
      .pipe(map(this.planBussines.mapFrom));
  }

  override getPlanBussinesIdAdmin(
    params: { idEmpresa: string }
  ): Observable<PlanBusinessModel> {
    return this.http
      .post<PlanBusinessEntity>(
        `${this.url}/PlanesEmpresa/GetCompanyByIdAdmin`,
        params
      )
      .pipe(map(this.planBussines.mapFrom));
  }

  // Terceros /

  override getThirdCompanyById(params: {
    IdTerceroEmpresa: string;
  }): Observable<ThirdCompanyResponseModel> {
    return this.http
      .post<ThirdCompanyResponseEntity>(`${this.url}/TercerosEmpresa/GetById`, {
        id: params.IdTerceroEmpresa,
      })
      .pipe(map(this.thirdCompany.mapFrom));
  }

  override getThirdCompany(params: {
    IdTipoDocumento: string;
    NumeroDocumento: string;
  }): Observable<ThirdCompanyResponseModel> {
    return this.http
      .post<ThirdCompanyResponseEntity>(
        `${this.url}/TercerosEmpresa/Search`,
        params
      )
      .pipe(map(this.thirdCompany.mapFrom));
  }

  override getThirdCompanyAll(params: {
    IdEmpresa: string;
  }): Observable<ThirdCompanyResponseModel> {
    return this.http
      .post<ThirdCompanyResponseEntity>(
        `${this.url}/TercerosEmpresa/GetAll`,
        params
      )
      .pipe(map(this.thirdCompany.mapFrom));
  }

  override insertThirdCompany(
    params: DataThirdCompanyEntity
  ): Observable<ThirdCompanyResponseModel> {
    return this.http
      .post<ThirdCompanyResponseEntity>(
        `${this.url}/TercerosEmpresa/Insert`,
        params
      )
      .pipe(map(this.thirdCompany.mapFrom));
  }

  override deleteThirdCompany(params: {
    Id: string;
  }): Observable<ThirdCompanyResponseModel> {
    return this.http
      .delete<ThirdCompanyResponseEntity>(
        `${this.url}/TercerosEmpresa/Delete`,
        { body: params }
      )
      .pipe(map(this.thirdCompany.mapFrom));
  }

  override updateThirdCompany(
    params: DataThirdCompanyEntity
  ): Observable<ThirdCompanyResponseModel> {
    return this.http
      .put<ThirdCompanyResponseEntity>(
        `${this.url}/TercerosEmpresa/Update`,
        params
      )
      .pipe(map(this.thirdCompany.mapFrom));
  }

  //**Invoice */
  override getTypeInvoice(): Observable<TypeInvoiceModel> {
    return this.http
      .get<TypeInvoiceEntity>(
        `${this.url}/FacturasPendientes/TipoFacturaGetAll`
      )
      .pipe(map(this.typeInvoice.mapFrom));
  }

  override getInvoiceAll(
    params: InvoiceModel
  ): Observable<InvoiceResponseModel> {
    return this.http
      .post<InvoiceResponseEntity>(
        `${this.url}/FacturasPendientes/FacturasPendientesGetAll`,
        params
      )
      .pipe(map(this.invoice.mapFrom));
  }

  override getProfessional(): Observable<ProfessionalModel> {
    return this.http
      .get<ProfessionalEntity>(
        `${this.url}/FacturasPendientes/GetProffesionalByCompanyId`
      )
      .pipe(map(this.professional.mapFrom));
  }

  override insertInvoice(
    params: InvoiceModel
  ): Observable<InvoiceResponseModel> {
    return this.http
      .post<InvoiceResponseEntity>(
        `${this.url}/FacturasPendientes/FacturasPendientesInsert`,
        params
      )
      .pipe(map(this.invoice.mapFrom));
  }

  override getInvoiceByDate(
    params: InvoiceModel
  ): Observable<PendingInvoiceReportModel> {
    return this.http
      .post<PendingInvoiceReportEntity>(
        `${this.url}/FacturasPendientes/GetFacturasReportByDate`,
        params
      )
      .pipe(map(this.invoiceReport.mapFrom));
  }

  /* Consent */

  override getConsent(): Observable<ConsentModel> {
    return this.http
      .get<ConsentEntity>(`${this.url}/Consentimientos/GetAll`)
      .pipe(map(this.consent.mapFrom));
  }

  override insertConsent(params: DataConsentModel): Observable<ConsentModel> {
    return this.http
      .post<ConsentEntity>(`${this.url}/Consentimientos/Insert`, params)
      .pipe(map(this.consent.mapFrom));
  }

  override deleteConsent(params: { id: string }): Observable<ConsentModel> {
    return this.http
      .delete<ConsentEntity>(`${this.url}/Consentimientos/Delete`, {
        body: params,
      })
      .pipe(map(this.consent.mapFrom));
  }

  override updateConsent(params: DataConsentModel): Observable<ConsentModel> {
    return this.http
      .put<ConsentEntity>(`${this.url}/Consentimientos/Update`, params)
      .pipe(map(this.consent.mapFrom));
  }

  /**Sedes */
  override getAllHeadquartersByBussines(): Observable<HeadquartersModel> {
    return this.http
      .get<HeadquartersModel>(`${this.url}/SedesEmpresa/GetAllByCompanyId`)
      .pipe(map(this.headquarters.mapFrom));
  }

  override getHeadquartersByCompanyid(
    params: { idServicio: string }
  ): Observable<HeadquartersModel> {
    return this.http
      .post<HeadquartersEntity>(
        `${this.url}/SedesEmpresa/ListByServiceId`,
        params
      )
      .pipe(map(this.headquarters.mapFrom));
  }

  override getHeadquartersAllByCompanyIdAdmin(params: { idEmpresa: string }): Observable<HeadquartersModel> {
    return this.http
      .post<HeadquartersEntity>(`${this.url}/SedesEmpresa/GetAllByCompanyIdAdmin`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override insertHeadquarters(params: DataHeadquartersEntity): Observable<HeadquartersModel> {
    return this.http
      .post<HeadquartersEntity>(`${this.url}/SedesEmpresa/Insert`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override insertHeadquartersAdmin(params: DataHeadquartersEntity): Observable<HeadquartersModel> {
    return this.http
      .post<HeadquartersEntity>(`${this.url}/SedesEmpresa/InsertAdmin`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override updateHeadquarters(params: DataHeadquartersEntity): Observable<HeadquartersModel> {
    return this.http
      .put<HeadquartersEntity>(`${this.url}/SedesEmpresa/Update`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override updateHeadquartersAdmin(params: DataHeadquartersEntity): Observable<HeadquartersModel> {
    return this.http
      .post<HeadquartersEntity>(`${this.url}/SedesEmpresa/UpdateAdmin`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override deleteHeadquarters(params: DataHeadquartersEntity): Observable<HeadquartersModel> {
    return this.http
      .put<HeadquartersEntity>(`${this.url}/SedesEmpresa/Update`, params)
      .pipe(map(this.headquarters.mapFrom));
  }


  /**Consultorio */

  override getAllOfficesByHeadquarters(params: {idSedeEmpresa:string}): Observable<OfficesModel> {
      return this.http.get(`${this.url}/ConsultoriosSedeEmpresa/GetAllByCompanyHeadquarterId/${params.idSedeEmpresa}`)
      .pipe(map(this.headquarters.mapFrom));
  }

  override getOfficeByHeadquartersIdAdmin(
    params: { idSedeEmpresa: string }
  ): Observable<OfficesModel> {
    return this.http
      .post<OfficesEntity>(
        `${this.url}/ConsultoriosSedeEmpresa/GetAllByCompanyHeadquarterIdAdmin`,
        params
      )
      .pipe(map(this.headquarters.mapFrom));
  }

  override insertOffices(params: DataOfficesEntity): Observable<OfficesModel> {
    return this.http
      .post<OfficesEntity>(`${this.url}/ConsultoriosSedeEmpresa/Insert`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override insertOfficesIdAdmin(params: DataOfficesEntity): Observable<OfficesModel> {
    return this.http
      .post<OfficesEntity>(`${this.url}/ConsultoriosSedeEmpresa/InsertAdmin`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override updateOffices(params: DataOfficesEntity): Observable<OfficesModel> {
    return this.http
      .put<OfficesEntity>(`${this.url}/ConsultoriosSedeEmpresa/Update`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override updateOfficesIdAdmin(params: DataOfficesEntity): Observable<OfficesModel> {
    return this.http
      .post<OfficesEntity>(`${this.url}/ConsultoriosSedeEmpresa/UpdateAdmin`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  override deleteOffices(params: DataOfficesEntity): Observable<OfficesModel> {
    return this.http
      .delete<OfficesEntity>(`${this.url}/ConsultoriosSedeEmpresa/Delete`, { body: params })
      .pipe(map(this.headquarters.mapFrom));
  }

  override deleteOfficesIdAdmin(params: { id: string }): Observable<OfficesModel> {
    return this.http
      .post<OfficesEntity>(`${this.url}/ConsultoriosSedeEmpresa/DeleteAdmin`, params)
      .pipe(map(this.headquarters.mapFrom));
  }

  /**Convenio */
  override getAllConveniosByEmpresa(): Observable<ConvenioModel> {
    return this.http
      .get<ConvenioModel>(`${this.url}/ConveniosEmpresa/GetAllByCompanyId`)
      .pipe(map(this.convenio.mapFrom));
  }

  override insertConvenio(
    params: DataConvenioEntity
  ): Observable<ConvenioModel> {
    return this.http
      .post<ConvenioEntity>(`${this.url}/ConveniosEmpresa/Insert`, params)
      .pipe(map(this.convenio.mapFrom));
  }

  override updateConvenio(
    params: DataConvenioEntity
  ): Observable<ConvenioModel> {
    return this.http
      .put<ConvenioEntity>(`${this.url}/ConveniosEmpresa/Update`, params)
      .pipe(map(this.convenio.mapFrom));
  }

  override deleteConvenio(
    params: DataConvenioEntity
  ): Observable<ConvenioModel> {
    return this.http
      .delete<ConvenioEntity>(`${this.url}/ConveniosEmpresa/Delete`, {
        body: params,
      })
      .pipe(map(this.convenio.mapFrom));
  }

  /**Invoice RIPS Configuration */
  override getInvoiceRIPSConfigurationByCompany(): Observable<InvoiceRIPSConfigurationModel> {
    return this.http
      .get<InvoiceRIPSConfigurationModel>(
        `${this.url}/EmpresaDatoFacturacion/GetByEmpresa`
      )
      .pipe(map(this.invoiceRIPSConfiguration.mapFrom));
  }

  override getInvoiceRIPSByCompanyIdAdmin(
    params: { idEmpresa: string }
  ): Observable<InvoiceRIPSConfigurationModel> {
    return this.http
      .post<InvoiceRIPSConfigurationEntity>(
        `${this.url}/EmpresaDatoFacturacion/GetByEmpresaAdmin`,
        params
      )
      .pipe(map(this.invoiceRIPSConfiguration.mapFrom));
  }

  override insertInvoiceRIPSConfiguration(
    params: DataInvoiceRIPSConfigurationEntity
  ): Observable<InvoiceRIPSConfigurationModel> {
    return this.http
      .post<InvoiceRIPSConfigurationEntity>(
        `${this.url}/EmpresaDatoFacturacion/Insert`,
        params
      )
      .pipe(map(this.invoiceRIPSConfiguration.mapFrom));
  }

  override insertInvoiceRIPSByCompanyIdAdmin(
    params: DataInvoiceRIPSConfigurationEntity
  ): Observable<InvoiceRIPSConfigurationModel> {
    return this.http
      .post<InvoiceRIPSConfigurationEntity>(
        `${this.url}/EmpresaDatoFacturacion/InsertAdmin`,
        params
      )
      .pipe(map(this.invoiceRIPSConfiguration.mapFrom));
  }

  override updateInvoiceRIPSConfiguration(
    params: DataInvoiceRIPSConfigurationEntity
  ): Observable<InvoiceRIPSConfigurationModel> {
    return this.http
      .put<InvoiceRIPSConfigurationEntity>(
        `${this.url}/EmpresaDatoFacturacion/Update`,
        params
      )
      .pipe(map(this.invoiceRIPSConfiguration.mapFrom));
  }

  override updateInvoiceRIPSByCompanyIdAdmin(
    params: DataInvoiceRIPSConfigurationEntity
  ): Observable<InvoiceRIPSConfigurationModel> {
    return this.http
      .post<InvoiceRIPSConfigurationEntity>(
        `${this.url}/EmpresaDatoFacturacion/UpdateAdmin`,
        params
      )
      .pipe(map(this.invoiceRIPSConfiguration.mapFrom));
  }

  /** Empresa */

  override getTypeBusiness(): Observable<TypeBusinessModel> {
    return this.http
      .get<TypeBusinessModel>(`${this.url}/TiposEmpresa/GetAll`)
      .pipe(map(this.typeBusiness.mapFrom));
  }
  override getBusinessAll(): Observable<BusinessModel<DataBusinessModel[]>> {
    return this.http
      .get<BusinessEntity<DataBusinessEntity[]>>(`${this.url}/Empresas/GetAll`)
      .pipe(map(this.bussinessAdmin.mapFrom));
  }

  override getBusinessById(): Observable<BusinessModel> {
    return this.http
      .get<BusinessModel>(`${this.url}/Empresas/GetById`)
      .pipe(map(this.bussiness.mapFrom));
  }

  override insertBusiness(
    params: DataBusinessModel
  ): Observable<BusinessModel> {
    return this.http
      .post<BusinessEntity>(`${this.url}/Empresas/Insert`, params)
      .pipe(map(this.bussiness.mapFrom));
  }

  override updateBusiness(
    params: DataBusinessModel
  ): Observable<BusinessModel> {
    return this.http
      .put<BusinessEntity>(`${this.url}/Empresas/Update`, params)
      .pipe(map(this.bussiness.mapFrom));
  }

  override insertDemoBusiness(
    params: DataDemoBusinessModel
  ): Observable<DemoBusinessModel> {
    return this.http
      .post<DemoBusinessEntity>(
        `${this.url}/Empresas/InsertUsuarioDemo`,
        params
      )
      .pipe(map(this.demoBusiness.mapFrom));
  }

  override updateLogoBusiness(
    params: DataBusinessModel
  ): Observable<BusinessModel> {
    return this.http
      .put<BusinessEntity>(`${this.url}/Empresas/LogoUpdate`, params)
      .pipe(map(this.bussiness.mapFrom));
  }

 /** Cargos */

  override getCollaboratorPosition(params: {
    idColaboradorEmpresa: string;
  }): Observable<CollaboratorPositionModel> {
    return this.http
      .post<CollaboratorPositionEntity>(`${this.url}/ColaboradoresEmpresaCargo/ByCompanyContributorId`, {
        idColaboradorEmpresa: params.idColaboradorEmpresa,
      })
      .pipe(map(this.collaboratorPosition.mapFrom));
  }

  override updateCollaboratorPosition(
    params: DataCollaboratorPositionModel
  ): Observable<CollaboratorPositionModel> {
    return this.http
      .put<CollaboratorPositionEntity>(`${this.url}/ColaboradoresEmpresaCargo/Update`, params)
      .pipe(map(this.collaboratorPosition.mapFrom));
  }

  override insertCollaboratorPosition(
    params: DataCollaboratorPositionModel
  ): Observable<CollaboratorPositionModel> {
    return this.http
      .post<CollaboratorPositionEntity>(
        `${this.url}/ColaboradoresEmpresaCargo/Insert`,
        params
      )
      .pipe(map(this.collaboratorPosition.mapFrom));
  }

  override insertScheduleProfessional(
    params: DataScheduleProfessionalModel[]
  ): Observable<ScheduleProfessionalModel> {
    return this.http
      .post<ScheduleProfessionalEntity>(
        `${this.url}/AgendasHorarioProfesional/Insert`,
        params
      )
      .pipe(map(this.scheduleProfessional.mapFrom));
  }

  override updateScheduleProfessional(
    params: DataScheduleProfessionalModel[]
  ): Observable<ScheduleProfessionalModel> {
    return this.http
      .put<ScheduleProfessionalEntity>(
        `${this.url}/AgendasHorarioProfesional/Update`,
        params
      )
      .pipe(map(this.scheduleProfessional.mapFrom));
  }

  override getScheduleProfessionalByIdConpany(
    params: DataScheduleProfessionalModel
  ): Observable<ScheduleProfessionalModel> {
    return this.http
      .post<ScheduleProfessionalEntity>(
        `${this.url}/AgendasHorarioProfesional/GetAllByCompanyContributorId`,
        params
      )
      .pipe(map(this.scheduleProfessional.mapFrom));
  }


  override getDocumentsSystem(): Observable<DocumentsSystemModel> {
    return this.http.get<DocumentsSystemEntity>(
      `${this.url}/DocumentosSistema/GetAll`
    )
      .pipe(
        map(
          this.documentssystem.mapFrom
        )
      );
  }

  override createDocumentSystem( params: DataDocumentsSystemModel): Observable<DocumentsSystemModel> {
    return this.http.post<DocumentsSystemEntity>(
      `${this.url}/DocumentosSistema/Insert`,
      params )
      .pipe(
        map( this.documentssystem.mapFrom )
      );
  }


  override updateDocumentsSystem(
    params: DataDocumentsSystemModel
  ): Observable<DocumentsSystemModel> {

    return this.http.put<DocumentsSystemEntity>(
      `${this.url}/DocumentosSistema/Update`,
      params
    )
      .pipe(
        map(
          this.documentssystem.mapFrom
        )
      );
  }


  override getFileDocumentsSystem(
    
  ): Observable<FileDocumentsSystemModel> {

    return this.http.get<FileDocumentsSystemEntity>(
      `${this.url}/ArchivosDocumentoSistema/GetAll`
    )
      .pipe(
        map(
          this.filedocumentssystem.mapFrom
        )
      );
  }

  override createFileDocumentsSystem(
    params: DataFileDocumentsSystemModel
  ): Observable<FileDocumentsSystemModel> {

    return this.http.post<FileDocumentsSystemEntity>(
      `${this.url}/ArchivosDocumentoSistema/Insert`,
      params
    )
      .pipe(
        map(
          this.filedocumentssystem.mapFrom
        )
      );
  }


  override updateFileDocumentsSystem(
    params: DataFileDocumentsSystemModel
  ): Observable<FileDocumentsSystemModel> {

    return this.http.put<FileDocumentsSystemEntity>(
      `${this.url}/ArchivosDocumentoSistema/Update`,
      params
    )
      .pipe(
        map(
          this.filedocumentssystem.mapFrom
        )
      );
  }


  override getChannelSend(): Observable<ChannelSendModel> {

    return this.http.get<ChannelSendEntity>(
      `${this.url}/CanalesEnvio/GetAll`
    )
      .pipe(
        map(
          this.channelsend.mapFrom
        )
      );
  }


  override createChannelSend(
    params: DataChannelSendEntity
  ): Observable<ChannelSendModel> {

    return this.http.post<ChannelSendEntity>(
      `${this.url}/CanalesEnvio/Insert`,
      params
    )
      .pipe(
        map(
          this.channelsend.mapFrom
        )
      );
  }


  override updateChannelSend(
    params: DataChannelSendModel
  ): Observable<ChannelSendModel> {

    return this.http.put<ChannelSendEntity>(
      `${this.url}/CanalesEnvio/Update`,
      params
    )
      .pipe(
        map(
          this.channelsend.mapFrom
        )
      );
  }


  override getFileDocumentsSystemById(
    params: DataFileDocumentsSystemModel
  ): Observable<FileDocumentsSystemModel> {

    return this.http.post<FileDocumentsSystemEntity>(
      `${this.url}/ArchivosDocumentoSistema/ByIdDocumentSystem`, params
    )
      .pipe(
        map(
          this.filedocumentssystem.mapFrom
        )
      );
  }


  override getAllMenu(
    
  ): Observable<MenuModel> {

    return this.http.get<MenuEntity>(
      `${this.url}/Menus/GetAll`
    )
      .pipe(
        map(
          this.menu.mapFrom
        )
      );
  }


  override insertmenu(
    params: DataMenuModel
  ): Observable<MenuModel> {

    return this.http.post<MenuEntity>( `${this.url}/Menus/Insert`,params).pipe(map(this.menu.mapFrom));
  }


  override updatemenu(
    params: DataMenuModel
  ): Observable<MenuModel> {

    return this.http.put<MenuEntity>(
      `${this.url}/Menus/Update`,
      params
    ).pipe(
        map(
          this.menu.mapFrom
        )
      );
  }


  override getAllPerfil(): Observable<PerfilModel> {
  return this.http.get<PerfilEntity>(`${this.url}/Perfiles/GetAll`).pipe(map(this.perfil.mapFrom));
  }

  override insertperfil(
    params: DataPerfilModel
  ): Observable<PerfilModel> {

    return this.http.post<PerfilEntity>(
      `${this.url}/Perfiles/Insert`,
      params
    )
      .pipe(
        map(
          this.perfil.mapFrom
        )
      );
  }


  override updateperfil(
    params: DataPerfilModel
  ): Observable<PerfilModel> {

    return this.http.put<PerfilEntity>(
      `${this.url}/Perfiles/Update`,
      params
    )
      .pipe(
        map(
          this.perfil.mapFrom
        )
      );
  }


  override getAllPerfilMenu(
    
  ): Observable<PerfilMenuModel> {

    return this.http.get<PerfilMenuEntity>(
      `${this.url}/PerfilesMenu/GetAll`
    )
      .pipe(
        map(
          this.perfilmenu.mapFrom
        )
      );
  }

    override insertPerfilMenu(
    params: DataPerfilMenuModel
  ): Observable<PerfilMenuModel> {

    return this.http.post<PerfilMenuEntity>(
      `${this.url}/PerfilesMenu/Insert`,
      params
    )
      .pipe( 
        map(
          this.perfilmenu.mapFrom
        )
      );
  }

  override deletePerfilMenu(
    params: DataPerfilMenuModel
  ): Observable<PerfilMenuModel> {
     return this.http
      .delete<PerfilMenuEntity>(`${this.url}/PerfilesMenu/Delete`, {
        body: params,
      })
      .pipe(map(this.perfilmenu.mapFrom));
  }


  override getAllPerfilMenuById(
    params: DataPerfilMenuModel
  ): Observable<PerfilMenuModel> {

    return this.http.post<PerfilMenuEntity>(
      `${this.url}/PerfilesMenu/GetAllByIdProfile`,
      params
    )
      .pipe(
        map(
          this.perfilmenu.mapFrom
        )
      );
  }


  override getBusinessByPaged(
    params: {PageNumber:number,PageSize:number, Search:string}
  ): Observable<BusinessModel<DataBusinessModel[]>> {

    return this.http.post<BusinessEntity<DataBusinessEntity[]>>(
      `${this.url}/Empresas/GetPaged`,
      params
    )
      .pipe(
        map(
          this.bussinessAdmin.mapFrom
        )
      );
  }


  override getBusinessByIdAdmin( params:{idEmpresa:string}): Observable<BusinessModel> {

    return this.http.post<BusinessEntity>(
      `${this.url}/Empresas/GetByIdAdmin`,
      params
    )
      .pipe(
        map(
          this.business.mapFrom
        )
      );
  }

}